import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class SmartFeedCardAlignment extends BaseOption {
  static label = "Card Alignment";
  static userInterfaceComponent = {
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Left",
          value: "left",
        },
        {
          label: "Center",
          value: "center",
        },
        {
          label: "Right",
          value: "right",
        },
      ],
    },
  };

  static defaultValue = "left";

  static canShow(smartFeedType) {
    return smartFeedType === "grid";
  }
}
